import {
  createApiMethodObject,
  createInfiniteQueryKeyObject,
  createInfiniteQueryOptionsObject,
  createMutation,
  createQueryKeyObject,
  createQueryOptionsObject,
} from '@common/api/normalizeApi';
import { checkServerResponse } from '@common/utils';

import { ENV } from '@/constants';

import * as AuthQuery from '../../__generated__/api/auth/@tanstack/react-query.gen';
import { client as AuthClient } from '../../__generated__/api/auth/client.gen';
import * as AuthSdk from '../../__generated__/api/auth/sdk.gen';
import * as DpgQuery from '../../__generated__/api/dpg/@tanstack/react-query.gen';
import { client as DpgClient } from '../../__generated__/api/dpg/client.gen';
import * as DpgSdk from '../../__generated__/api/dpg/sdk.gen';
import * as UnauthQuery from '../../__generated__/api/unauth/@tanstack/react-query.gen';
import { client as UnauthClient } from '../../__generated__/api/unauth/client.gen';
import * as UnauthSdk from '../../__generated__/api/unauth/sdk.gen';

const { NEXT_PUBLIC_API_DOMAIN, NEXT_PUBLIC_DPG_API_DOMAIN } = ENV;

AuthClient.setConfig({
  baseUrl: NEXT_PUBLIC_API_DOMAIN,
});

UnauthClient.setConfig({
  baseUrl: NEXT_PUBLIC_API_DOMAIN,
});

DpgClient.setConfig({
  baseUrl: NEXT_PUBLIC_DPG_API_DOMAIN,
});

AuthClient.interceptors.response.use(async (res) => {
  await checkServerResponse(res);

  return res;
});

UnauthClient.interceptors.response.use(async (res) => {
  await checkServerResponse(res);

  return res;
});

export { AuthClient };

export const AuthApi = createApiMethodObject(AuthSdk);
export const UnauthApi = createApiMethodObject(UnauthSdk);
export const DpgApi = createApiMethodObject(DpgSdk);

export const AuthQueryOptions = createQueryOptionsObject(AuthQuery);
export const UnauthQueryOptions = createQueryOptionsObject(UnauthQuery);
export const DpgQueryOptions = createQueryOptionsObject(DpgQuery);

export const AuthQueryKey = createQueryKeyObject(AuthQuery);
export const UnauthQueryKey = createQueryKeyObject(UnauthQuery);
export const DpgQueryKey = createQueryKeyObject(DpgQuery);

export const AuthInfiniteQueryKey = createInfiniteQueryKeyObject(AuthQuery);
export const UnauthInfiniteQueryKey = createInfiniteQueryKeyObject(UnauthQuery);
export const DpgInfiniteQueryKey = createInfiniteQueryKeyObject(DpgQuery);

export const AuthMutation = createMutation(AuthQuery);
export const UnauthMutation = createMutation(UnauthQuery);
export const DpgMutation = createMutation(DpgQuery);

export const AuthInfiniteQueryOptions =
  createInfiniteQueryOptionsObject(AuthQuery);
export const UnauthInfiniteQueryOptions =
  createInfiniteQueryOptionsObject(UnauthQuery);
export const DpgInfiniteQueryOptions =
  createInfiniteQueryOptionsObject(DpgQuery);
